import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { config } from '../../../../constants';
import { getUrlWithToken } from '../../../../utils';

const CardButton = ({ document }) => {
  const { t } = useTranslation();
  const { flowId } = document;

  return (
    <>
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={() => getUrlWithToken(`${config.FIRMA_FRONT_URL}/validate/${flowId}`)}
        >
          {t('cardButton:viewSignedDocument')}
        </Button>
      </Grid>

    </>
  );
};

const mapStateToProps = (state) => {
  return {
    appConfig: state.config
  };
};

CardButton.propTypes = {
  document: PropTypes.object.isRequired
};

export default connect(mapStateToProps, null)(CardButton);
